module.exports = __webpack_public_path__ + "img/tty-answer.b4262c59.svg";